







import mixins from 'vue-typed-mixins';
import { HorizontalBar } from 'vue-chartjs';
import DashboardUtils, {
  DashboardTile,
  TileSubmissionStatusOptions,
} from '@/utils/DashboardUtils';
import { OversightOrganization } from '@/utils/OversightUtils';
import { SurveyGroup } from '@/utils/SurveyUtils';
import { TileAPIParams } from '@/utils/TileUtils';

const Chart = mixins().extend({
  extends: HorizontalBar,

  props: {
    tile: {
      type: Object as () => DashboardTile<TileSubmissionStatusOptions>,
    },
    data: {
      type: Object as () => {
        notstarted: number;
        notsubmitted: number;
        submitted: number;
        complete: number;
      },
    },
  },

  computed: {
    // easier to use internal mapping of the data
    internal(): {
      key: string;
      value: number;
      color: string;
    }[] {
      return [
        {
          key: 'notstarted',
          value: this.data?.notstarted || 0,
          color: '#f99a91',
        },
        {
          key: 'notsubmitted',
          value: this.data?.notsubmitted || 0,
          color: '#ecd374',
        },
        {
          key: 'submitted',
          value: this.data?.submitted || 0,
          color: '#18b358',
        },
        {
          key: 'complete',
          value: this.data?.complete || 0,
          color: '#399adb',
        },
      ];
    },

    chartData(): any {
      return {
        labels: this.internal?.map((item) =>
          this.$tc(`page.dashboard.tile.type.submission_status.${item.key}`)
        ),
        datasets: [
          {
            backgroundColor: this.internal?.map((item) => item.color),
            data: this.internal?.map((item) => item.value),
          },
        ],
      };
    },

    chartOptions(): any {
      return {
        title: {
          display: false,
        },
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              ticks: {
                stepSize: 1,
                beginAtZero: true,
              },
            },
          ],
        },
        responsive: true,
        maintainAspectRatio: false,
      };
    },
  },

  mounted() {
    // @ts-ignore
    this.renderChart(this.chartData, this.chartOptions);
  },

  watch: {
    chartData() {
      this.reload();
    },
    chartOptions() {
      this.reload();
    },
  },

  methods: {
    reload() {
      this.$data._chart.data = this.chartData;
      this.$data._chart.options = this.chartOptions;
      this.$data._chart.update();
    },
  },
});

export default mixins().extend({
  components: {
    Chart,
  },

  props: {
    tile: {
      type: Object as () => DashboardTile<TileSubmissionStatusOptions>,
    },

    params: {
      type: Object as () => TileAPIParams,
    },
  },

  data(): {
    data?: {
      notstarted: number;
      notsubmitted: number;
      submitted: number;
      complete: number;
    };
  } {
    return {
      data: undefined,
    };
  },

  mounted() {
    this.load();
  },

  watch: {
    params(current, previous) {
      if (
        current.surveygroup !== previous.surveygroup ||
        current.oversight !== previous.oversight
      ) {
        this.load();
      }
    },
  },

  methods: {
    async load() {
      if (this.params?.surveygroup?.id) {
        try {
          this.data = undefined;
          this.$alert.hide('load');
          this.data = ((await DashboardUtils.oversight({
            id: this.params?.oversight?.id,
            group: this.params?.surveygroup?.id,
          })) as any)?.status;
        } catch (error) {
          this.$alert.show('load', {
            type: 'error',
            messages: this.$handleAPIError(error),
          });
        }
      }
    },
  },
});
